import { api } from '../lib/api'

export type Mode = 'attention' | 'contability' | 'calendar' | 'admin'

export type MePermissions = { attention: boolean; contability: boolean; calendar: boolean; admin: boolean }

export type MeHealthCenter = {
  id: number
  name: string
  logo_url: string
  has_logo: boolean
  account_type: 'freemium' | 'paid'
  account_state: 'open' | 'soon' | 'closed'
  has_current_paid_payment: boolean
  patients_count: number
  administrator: boolean
  profession: { key: string; title: string; name: string }
  permissions: MePermissions
  default_mode: Mode
}

export type Me = {
  professional: { id: number; name: string; email: string; rut: string; state: string; admin: boolean }
  health_centers: MeHealthCenter[]
}

export function fetchMe(): Promise<Me> {
  return api.get<Me>('/api/me')
}

let pendingMe: Promise<Me> | null = null

async function fetchSharedMe(): Promise<Me> {
  try {
    return await fetchMe()
  } finally {
    pendingMe = null
  }
}

/** The root loader and a page loader that needs `me` run together, so they share one request. */
export function getMe(): Promise<Me> {
  pendingMe ??= fetchSharedMe()
  return pendingMe
}
